import React from "react";
import { Grid } from "@material-ui/core";

interface Props {
  title: string;
}

const DeleteTitle = (props: Props) => {
  return (
    <Grid container spacing={2} style={{paddingLeft: "22px"}}>
      <Grid item xs={12}>
        <div style={{ textAlign: "center", paddingTop: "1rem" }}>
          <img src="/assets/images/icon-delete-outlined.svg" alt="delete" />
        </div>
      </Grid>

      <Grid item xs={12}>
        <div
          style={{
            textAlign: "center",
            paddingBottom: "1rem",
            color: "#F52D5C",
          }}
        >
          {props.title}
        </div>
      </Grid>
    </Grid>
  );
};

export default DeleteTitle;
